import { Layout, Typography } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../navbar/navbar";
import "./yettey-header.scss";

export interface YetteyHeaderProps {
  isMobile: boolean;
}

const { Text } = Typography;
export const YetteyHeader: React.FC<YetteyHeaderProps> = (props) => {
  const { Header } = Layout;

  return (
    <Header className="d-flex justify-content-center bg-primary">
      <Link to="/">
        <Text className="brand-header">YETTEY</Text>
      </Link>
      {!props.isMobile ? <Navbar /> : null}
    </Header>
  );
};

export default YetteyHeader;
